import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {environment} from '../../environments/environment';

@Injectable()
export class ReportsService {
  constructor(private http: Http) {
  }

  getReportHistory(page, count, column, order, search, userTimeZoneOffset) {
    let queryParams = `?page=${page}&size=${count}`;
    if (column && order) {
      queryParams += `&sort=${column + ',' + order}`;
    }
    if (search && search !== '') {
      queryParams += '&criteria=' + encodeURIComponent(JSON.stringify({name: search}));
    }
    
    queryParams+='&userTimeZoneOffset='+userTimeZoneOffset;
    
    return this.http.get(`${environment.baseURL}${environment.report}/history${queryParams}`)
      .map((res: Response) => {
        return res;
      });
  }

  deleteReport(file_ruid) {
    // console.log('DELETE REPORT 2' + file_ruid);
    let deleteParams = `?ruid=${file_ruid}`;
    return this.http.delete(`${environment.baseURL}${environment.report}/history/deletereport${deleteParams}`).map(res => res);
      // .map((res: Response) => {
      //   return res;
      // }).subscribe();
  }

}


// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/reports.service.ts